import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
interface InputProps {
  label: string;
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  success?: string;
  fullWidth?: boolean;
  required?: boolean;
  name?: string;
}
const Input = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  success,
  fullWidth = true,
  required = false,
  name
}: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = type === 'password' && showPassword ? 'text' : type;
  return <div className={`mb-4 ${fullWidth ? 'w-full' : ''}`} data-id="element-29">
      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-30">
        {label} {required && <span className="text-red-500" data-id="element-31">*</span>}
      </label>
      <div className="relative" data-id="element-32">
        <input type={inputType} placeholder={placeholder} value={value} onChange={onChange} name={name} className={`min-h-[44px] w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-1 
            ${error ? 'border-red-500 focus:ring-red-500' : success ? 'border-green-500 focus:ring-green-500' : 'border-gray-300 focus:ring-blue-500'}`} data-id="element-33" />
        {type === 'password' && <button type="button" className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" onClick={() => setShowPassword(!showPassword)} data-id="element-34">
            {showPassword ? <EyeOffIcon size={20} data-id="element-35" /> : <EyeIcon size={20} data-id="element-36" />}
          </button>}
      </div>
      {error && <p className="mt-1 text-sm text-red-600 flex items-center" data-id="element-37">
          <span className="mr-1" data-id="element-38">⚠️</span> {error}
        </p>}
      {success && <p className="mt-1 text-sm text-green-600 flex items-center" data-id="element-39">
          <span className="mr-1" data-id="element-40">✓</span> {success}
        </p>}
    </div>;
};
export default Input;